<div class="hide-tooltip">
    <ng-content></ng-content>
</div>